import { FilterGroup } from 'components/Filters/components/FilterModal'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import { FilterStore } from 'components/Filters/FilterStore'
import useApiService from 'services/api'
import { useUserOptions } from 'services/users'
import { createFilterColumnHelper } from '../commonColumnHelpers'
import { COMMON_COLUMNS } from '../CommonColumnsInfo'
import { RangeFilter } from 'components/Filters/fields/RangeFilter'

type DoorsAccountGroupProps = {
  filterStore: FilterStore
  campaignOptions?: any
  hideCampaignsFilter?: boolean
}

/**
 * Hook variant that returns the Doors Account-group filter elements as a
 * Fragment (no FilterGroup wrapper). Useful for sortable filtersets where
 * FilterModal's alphabetical walker needs each filter as a direct
 * React.Children so it can extract titles and bucket by first letter.
 */
export function useDoorsAccountGroupFilters({
  filterStore,
  campaignOptions,
  hideCampaignsFilter: hideCampaigns,
}: DoorsAccountGroupProps) {
  const api = useApiService()
  const { data: stageOptions } = api.useGetSalesStageOptions(true)
  const { data: userOptions } = useUserOptions({
    onlyActive: true,
    withNoneOption: true,
  })
  const { data: tagsOptions } = api.useGetTagsOptions(true)
  const { data: distributorOptions } =
    api.useGetCompanyDistributorsOptions(true)
  const { data: gpoOptions } = api.useGetCompanyGPOsOptions(true)
  const commonFilterHelper = createFilterColumnHelper({
    columns: COMMON_COLUMNS,
  })

  return (
    <>
      {campaignOptions && !hideCampaigns && (
        <SelectFilter
          {...commonFilterHelper.retrieveProps('campaigns')}
          options={campaignOptions as any}
          filterStore={filterStore}
        />
      )}
      <SelectFilter
        {...commonFilterHelper.retrieveProps('sales_stages')}
        options={stageOptions as any}
        filterStore={filterStore}
      />
      <SelectFilter
        {...commonFilterHelper.retrieveProps('account_owners')}
        options={userOptions as any}
        filterStore={filterStore}
      />
      <SelectFilter
        filterKey="door_taglist"
        title="Door Tags"
        options={tagsOptions as any}
        filterStore={filterStore}
      />
      <SelectFilter
        {...commonFilterHelper.retrieveProps('taglist')}
        title="Chain Tags"
        options={tagsOptions as any}
        filterStore={filterStore}
      />
      <RangeFilter
        {...commonFilterHelper.retrieveProps('deal_count')}
        store={filterStore}
      />
      <RangeFilter
        {...commonFilterHelper.retrieveProps('note_count')}
        store={filterStore}
      />
      <RangeFilter
        {...commonFilterHelper.retrieveProps('contact_count')}
        store={filterStore}
      />
      <SelectFilter
        filterKey="door_distributors"
        title="Door Distributors"
        options={distributorOptions as any}
        filterStore={filterStore}
      />
      <SelectFilter
        {...commonFilterHelper.retrieveProps('distributors')}
        title="Chain Distributors"
        filterStore={filterStore}
        options={distributorOptions as any}
      />
      <SelectFilter
        filterKey="door_gpos"
        title="Door GPOs"
        options={gpoOptions as any}
        filterStore={filterStore}
      />
      <SelectFilter
        {...commonFilterHelper.retrieveProps('gpos')}
        title="Chain GPOs"
        filterStore={filterStore}
        options={gpoOptions as any}
      />
    </>
  )
}

export function CommonFiltersetDoorsAccountGroup(
  props: DoorsAccountGroupProps
) {
  const filters = useDoorsAccountGroupFilters(props)
  return <FilterGroup title="Account">{filters}</FilterGroup>
}
